export default {
  tasksReward: 'مكافأة المهام',
  lastWeekReward: 'مكافأة الأسبوع الماضي',
  thisWeekReward: 'مكافأة هذا الأسبوع',
};
